<template>
  <div
    class="customer"
    v-loading="loading"
    element-loading-text="等待扫码"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div class="contentRight2">
      <!-- 客户管理界面 -->
      <div v-if="pages ==1">
        <div class="rightHead">
          <div style="margin:0 0 0 25px;font-size:15px;padding-top:16px;color:#707070;">会员管理</div>
        </div>
        <div class="commodityHead">
          <div class="row">
            <el-button
              class="button3"
              size="small"
              style="width:100px;"
              type="primary"
              @click="pages = 2"
            >会员卡管理</el-button>
            <!-- 判断有无会员卡 -->
            <!-- <el-button class="button3" type="primary" >设置会员卡</el-button> -->
            <el-button class="button2" size="small" @click="open" :disabled="disabled">会员开卡</el-button>
            <el-upload
              style="margin-left:10px;"
              class="upload-demo"
              action="https://api.yichengshi.cn/qrcapi/Goods_importGoodsNum"
              :http-request="handleAvatarSuccess2"
              :show-file-list="false"
              multiple
            >
              <el-select
                style="width:220px;"
                size="small"
                v-model="upLoadVip"
                placeholder="使用批量导入时请选择会员卡"
                @change="selectChange(upLoadVip,1)"
              >
                <el-option
                  v-for="(item,index) in vipList"
                  :label="item.cardName"
                  :value="item.shopMemberCardId"
                  :key="index"
                ></el-option>
              </el-select>
              <el-button class="loadup" style="height:30px;" size="small" type="primary">批量导入会员</el-button>
            </el-upload>
              <div class="isEnable">
                <span class="content2-ygq2" v-if="isExpireShow">已过期</span>
                <span class="content2-jyz2" v-if="isEnableShow">禁用中</span>
              </div>
            <div style="margin-left:10px;margin-top:8px;font-size:12px;cursor:pointer">
              <img src="../../assets/icon/xz.png" alt />
              <span style="color:#409eff;">
                <a :href="url+'/download/导入会员模板.xls'">下载模板</a>
              </span>
            </div>
            <div style="position: absolute;right:120px;">
              <el-button type="primary" size="small" @click="send_coupon">发券</el-button>
            </div>
          </div>
          <div style="margin-top:10px;">
            <el-input
              style="width:180px;"
              placeholder="输入商店名字"
              v-model="shopName"
            ></el-input>
            <el-input
              style="width:180px;margin-left:10px"
              placeholder="输入手机号搜索会员"
              @input="change(value)"
              v-model="value"
              @blur="phoneNumberBlur"
            ></el-input><el-input
              style="width:180px;margin-left:10px"
              placeholder="输入最近几天生日"
              v-model="lastBirthdayDay"
            ></el-input><el-input
              style="width:180px;margin-left:10px"
              placeholder="输入多少天没消费的"
              v-model="lastActiveDay"
            ></el-input>
            <el-select v-model="profession" placeholder="请选择职业" style="margin-left:10px">
              <el-option
                v-for="item in professionList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            <el-button class="button4" @click="search" type="primary">搜索</el-button>
          </div>
        </div>
        <div class="content">
          <!-- 表格 -->
          <div>
            <el-table :data="tableData.list" style="width: 100%" @selection-change="handleSelectionChange" ref="multipleTable" :row-key="rowKey">
              <el-table-column type="selection" width="55" :reserve-selection="true">
              </el-table-column>
              <el-table-column label="客户" width="180">
                <template slot-scope="scope">
                  <div class="alignCenter">
                    <img v-if="scope.row.headLogo" :src="scope.row.headLogo" alt />
                    <img v-else src="../../assets/icon/hytx.png" alt />
                    <span style="margin-left:10px">{{scope.row.fullName}}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column align="center" prop="phoneNum" label="手机号码" width="180"></el-table-column>
              <el-table-column align="center" prop="wallet" label="余额/积分">
                <template slot-scope="scope">
                  <div style="text-align:left;padding-left:100px;box-sizing: border-box;">
                    <div>余额：{{scope.row.wallet}}</div>
                    <div>积分：{{scope.row.score}}</div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column align="center" prop="becomeMemberTime" label="注册时间"></el-table-column>
              <el-table-column align="center" prop="lastActiveTime" label="最后消费时间"></el-table-column>
              <!-- <el-table-column align="center" prop label="绑定">
                <template slot-scope="scope">
                  <div class="center">
                    <div v-if="scope.row.isBindWx === 1">微信</div>
                    <div v-else>无</div>
                  </div>
                </template>
              </el-table-column> -->
              <!-- <el-table-column align="center" prop label="会员卡状态">
                <template slot-scope="scope">
                  <div class="center">
                    <div v-if="scope.row.isExpire === 1" style=" color:#f62323; ">已过期</div>
                    <div v-else-if="scope.row.isEnable === 0" style=" color:#f6ae23; ">禁用中</div>
                    <div v-else>正常</div>
                  </div>
                </template>
              </el-table-column> -->
              <el-table-column align="center" label="操作">
                <template slot-scope="scope">
                  <el-button class="button5" 
                    @click="vipDetail(scope.row.shopMemberId, true, scope.row.shopMemberCardId)">详情</el-button>
                  <el-button
                    class="button5"
                    @click="openVipRecharge2(scope.row.shopMemberId,false)"
                  >充值</el-button>
                  <el-button
                    class="button5"
                    @click="single_sendCoupon(scope.row.shopMemberId)"
                  >发券</el-button>
                  <el-button
                    class="button5"
                    @click="delete_memeber(scope.row)"
                    plain
                  >删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <!-- 分页 -->
            <div v-if="tableData" class="block" style="float:right;margin:10px; 0">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="pageNumber"
                :page-size="pagesize"
                :page-sizes="[20, 50, 100, 150, 200, 250, 300, 400]"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tableData.totalCount"
              ></el-pagination>
            </div>
          </div>
        </div>
        <!-- 会员开卡弹出层 -->
        <div v-if="isPop" class="obs center">
          <div class="pop">
            <div class="title">
              <div v-if="vip == 1">填写信息</div>
              <div v-if="vip == 2">绑定</div>
              <div v-if="vip == 3">充值</div>
              <div style="color:gray;font-size:15px;cursor:pointer" @click="isPop = false,vip = 1">x</div>
            </div>
            <!-- 进度条 -->
            <!-- 填信息 -->
            <div v-if="vip == 1">
              <div class="plan column alignCenter">
                <div class="row center" style="margin-top: 15px;">
                  <div class="circleUp">
                    <div class="circle-white"></div>
                  </div>
                  <div class="br3"></div>

                  <div class="circle2"></div>

                  <div class="br3"></div>

                  <div class="circle2"></div>
                </div>
                <div class="text row class center">
                  <div>填信息</div>
                  <div style="color:#eee;margin-right:8px;">绑定</div>
                  <div style="color:#eee;margin-right:9px;">充值</div>
                </div>
              </div>
              <div id="vipInformation">
                <!-- 会员信息 -->
                <div class="content1">会员信息</div>
                <!-- 表单验证 -->
                <el-form
                  :model="ruleForm"
                  :rules="rules"
                  ref="ruleForm"
                  label-width="100px"
                  class="demo-ruleForm"
                  hide-required-asterisk
                  label-position="left"
                >
                  <div style="padding:10px 20px 0 20px;">
                    <el-form-item label="手机号码：" placeholder="输入手机号码">
                      <div style="color:#606266">{{ruleForm.phoneNum}}</div>
                    </el-form-item>
                    <el-form-item label="会员姓名：" placeholder="输入姓名" prop="fullName">
                      <el-input autofocus="true" v-model="ruleForm.fullName"></el-input>
                    </el-form-item>
                    <el-form-item label="性别：" prop="sex">
                      <el-radio-group v-model="ruleForm.sex">
                        <el-radio label="男"></el-radio>
                        <el-radio label="女"></el-radio>
                      </el-radio-group>
                    </el-form-item>
                    <el-form-item label="添加会员卡：" prop>
                      <el-select
                        v-model="ruleForm.shopMemberCardId"
                        @change="selectChange(ruleForm.shopMemberCardId,2)"
                        placeholder="未选择"
                      >
                        <el-option
                          v-for="(item,index) in vipList"
                          :label="item.cardName"
                          :value="item.shopMemberCardId"
                          :key="index"
                        ></el-option>
                      </el-select>
                      <div class="isEnable2">
                        <span class="content2-ygq2" v-if="isExpireShow2">已过期</span>
                        <span class="content2-jyz2" v-if="isEnableShow2">禁用中</span>
                      </div>
                    </el-form-item>
                  </div>
                  <div class="content1">完善会员信息（可选）</div>

                  <div style="padding:10px 20px 0 20px;">
                    <el-form-item label="生日" prop>
                      <div class="block">
                        <el-date-picker
                          value-format="yyyy-MM-dd"
                          v-model="ruleForm.birthday"
                          type="date"
                          placeholder="选择日期"
                        ></el-date-picker>
                      </div>
                    </el-form-item>
                    <el-form-item label="地区：" prop>
                      <!-- <el-row :gutter="20" style="margin:0">
                        <el-col :span="8" style="padding-left:0;">
                          <el-select v-model="ruleForm.provinceId" provinceId="省">
                            <el-option
                              v-for="(item,index) in cityData1"
                              :key="index"
                              :label="item.name"
                              :value="item.value"
                            ></el-option>
                          </el-select>
                        </el-col>
                        <el-col :span="8">
                          <el-select v-model="ruleForm.cityId" cityId="市">
                            <el-option
                              v-for="(item,index) in cityData3"
                              :key="index"
                              :label="item.name"
                              :value="item.value"
                            ></el-option>
                          </el-select>
                        </el-col>
                        <el-col :span="8" style="padding-right:0;">
                          <el-select v-model="ruleForm.districtId" districtId="区">
                            <el-option
                              v-for="(item,index) in cityData2"
                              :key="index"
                              :label="item.name"
                              :value="item.value"
                            ></el-option>
                          </el-select>
                        </el-col>
                      </el-row>-->
                      <div class="block">
                        <el-cascader v-model="ruleForm.provinceId" :options="options"></el-cascader>
                      </div>
                    </el-form-item>
                    <el-form-item label="详情地址：" prop placeholder="请输入备注信息">
                      <el-input type="textarea" v-model="ruleForm.remark"></el-input>
                    </el-form-item>
                  </div>
                  <el-form-item style="float:right;padding:0 20px;">
                    <el-button type="primary" class="button" @click="submitForm('ruleForm')">下一步</el-button>
                    <!-- <el-button @click="resetForm('ruleForm')">重置</el-button> -->
                  </el-form-item>
                </el-form>
              </div>
            </div>
            <!-- 绑定 -->
            <div v-if="vip == 2">
              <div class="plan column alignCenter">
                <div class="row center" style="margin-top: 15px;">
                  <div>
                    <div class="circle" @click="vip = 1"></div>
                  </div>
                  <div class="br2"></div>

                  <div class="circleUp">
                    <div class="circle-white"></div>
                  </div>

                  <div class="br3"></div>

                  <div class="circle2"></div>
                </div>
                <div class="text row class center">
                  <div>填信息</div>
                  <div style="margin-right:8px;">绑定</div>
                  <div style="color:#eee;margin-right:9px;">充值</div>
                </div>
              </div>
              <div class="center column">
                <!-- <img src="../../assets/icon/yiCity.png" style="height:364px;width:340px" alt /> -->
                <div class="qrcode">
                  <img src="../../assets/icon/yiCity.png" style="height:364px;width:340px" alt />
                  <canvas id="canvas" style="width: 350px;height: 350px;"></canvas>
                </div>
                <div style="font-size:12px;margin-top:30px;">请顾客使用微信扫一扫关注（{{mpNickName}}）完成绑定</div>
              </div>
              <el-button type="primary" class="button6" @click="goPay">下一步</el-button>
            </div>

            <!-- 充值 -->
            <div v-if="vip == 3">
              <div class="plan column alignCenter">
                <div class="row center" style="margin-top: 15px;">
                  <div>
                    <div class="circle" @click="vip = 1"></div>
                  </div>
                  <div class="br2"></div>

                  <div>
                    <div class="circle" @click="vip = 2"></div>
                  </div>

                  <div class="br2"></div>
                  <div class="circleUp">
                    <div class="circle-white"></div>
                  </div>
                </div>
                <div class="text row class center">
                  <div>填信息</div>
                  <div style="margin-right:8px;">绑定</div>
                  <div style="margin-right:9px;">充值</div>
                </div>
              </div>

              <div class="column center" style="margin-top:40px;">
                <!-- <img src="../../assets/icon/cz.png" style="height:200px;width:340px;" alt /> -->
                <!-- 会员卡预览 -->
                <div class="totalVip">
                  <div class="vipCard">
                    <div
                      class="changeColor"
                      v-if="cardColorArr.length !== 0"
                      :style="{background: `linear-gradient(to bottom right, ${popVipCard.startValue}, ${popVipCard.endValue}`,height:'200px',width:'340px'}"
                    ></div>

                    <div
                      class="name"
                      :style="{color:popVipCard.textColor,fontSize:'20px'}"
                    >{{popVipCard.cardName}}</div>
                    <div
                      class="welcome"
                      style="font-size:16px;margin-top:15px"
                    >{{popVipCard.cardSlogan}}</div>
                  </div>
                </div>
                <div class="price row alignCenter">
                  <span>充值金额：</span>
                  <div style="width:275px;">
                    <el-input v-model="rechargeNum" placeholder="输入金额" @blur="rechargeNumBlur">12312</el-input>
                  </div>
                </div>
                <div class="money">
                  <div
                    class="button7"
                    v-for="(item,index) in activityList"
                    :key="index"
                  >{{item.rechargeMoney}}元送{{item.handselMoney}}元</div>
                </div>
                <div class="moneyButton">
                  <el-button class="button2" style="width:75px" @click="recharge(1)">现金收款</el-button>
                  <el-button
                    class="button3"
                    style="width:75px"
                    @click="recharge(2)"
                    type="primary"
                  >扫码收款</el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="vipRecharge2" class="obs center">
          <div class="pop">
            <div class="title">
              <div v-if="vip == 1">充值会员</div>
              <div style="color:gray;font-size:15px;cursor:pointer" @click="vipRecharge2 = false">x</div>
            </div>
            <!-- 充值 -->
            <div class="column center" style="margin-top:40px;">
              <!-- <img src="../../assets/icon/cz.png" style="height:200px;width:340px;" alt /> -->
              <div class="totalVip">
                <div class="vipCard">
                  <div
                    class="changeColor"
                    v-if="cardColorArr.length !== 0"
                    :style="{background: `linear-gradient(to bottom right, ${vipDetailList.startValue}, ${vipDetailList.endValue}`,height:'200px',width:'340px'}"
                  ></div>

                  <div
                    class="name"
                    :style="{color:vipDetailList.textColor,fontSize:'20px'}"
                  >{{vipDetailList.cardName}}</div>
                  <div
                    class="welcome"
                    style="font-size:16px;margin-top:15px"
                  >{{vipDetailList.cardSlogan}}</div>
                </div>
              </div>
              <div class="price row alignCenter">
                <span>充值金额：</span>
                <div style="width:275px;">
                  <el-input v-model="rechargeNum" placeholder="输入金额" @blur="rechargeNumBlur">12312</el-input>
                </div>
              </div>
              <div class="money">
                <div
                  class="button7"
                  v-for="(item,index) in activityList"
                  :key="index"
                >{{item.rechargeMoney}}元送{{item.handselMoney}}元</div>
              </div>
              <div class="moneyButton">
                <el-button class="button2" style="width:75px" @click="recharge(1)">现金收款</el-button>
                <el-button
                  class="button3"
                  style="width:75px"
                  @click="recharge(2)"
                  type="primary"
                >扫码收款</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 会员卡管理界面 -->
      <div v-if="pages == 2" @click="ewm = false">
        <div class="rightHead">
          <div style="margin:0 0 0 25px;font-size:15px;padding-top:16px;color:#707070;">会员管理</div>
        </div>
        <div class="commodityHead" style="height:90px;">
          <el-breadcrumb class="elArrowText" separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>
              <a @click="toPages1" href="javascript:;">会员管理</a>
            </el-breadcrumb-item>
            <el-breadcrumb-item>会员卡管理</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div style="padding-top:100px;margin-left:20px;min-width:1600px;" class="alignCenter">
          <div class="totalVip">
            <div
              class="vipCard"
              @mouseleave="editLeaver(index,item.isEnable,item.isExpire)"
              v-for="(item,index) in vipList"
              :key="index"
            >
              <div
                class="changeColor"
                v-if="cardColorArr.length !== 0"
                :style="{background: `linear-gradient(to bottom right, ${item.startValue}, ${item.endValue})`}"
              ></div>

              <img
                @mouseenter="editHover(index,item.isEnable,item.isExpire)"
                style="position: absolute;top: 15px;left: 15px;"
                src="../../assets/icon/hykbj.png"
                alt
              />
              <!-- 禁用中图标 -->
              <img
                :ref="'none'+index"
                @mouseenter="editHover(index,item.isEnable,item.isExpire)"
                style="position: absolute;top: 0px;left: 15px;z-index:2"
                v-if="!item.isEnable"
                src="../../assets/icon/jyz.png"
                alt
              />
              <!-- 已过期中图标 -->
              <img
                :ref="'none2'+index"
                @mouseenter="editHover(index,item.isEnable,item.isExpire)"
                style="position: absolute;top: 0px;left: 15px;z-index:3"
                v-if="item.isExpire"
                src="../../assets/icon/ygq.png"
                alt
              />
              <!-- 编辑图标 -->
              <img
                :ref="index"
                @click="editVipCard(item)"
                style="  cursor: pointer;display:none;position: absolute;top: 30px;left: 88px;z-index:4"
                src="../../assets/icon/bj.png"
                alt
              />
              <img v-if="cardColor=='blue'" src="../../assets/icon/tjhyk2.png" alt />
              <div class="name" :style="{color:item.textColor}">{{item.cardName}}</div>
              <div class="welcome">{{item.cardSlogan}}</div>
              <div class="time" v-if="item.expireType == 0">有效期：永久</div>
              <div class="time" v-else-if="item.expireType == 1">有效期：{{item.expireDayNum}}天</div>
              <div class="time" v-else-if="item.expireType == 2">有效期至：{{item.endTime}}</div>
              <div class="discount">
                <span style="font-size:30px;">{{item.discount}}</span>折
              </div>
              <div class="share row center">
                <!-- <div>分享会员卡</div>
                <div style="margin-left:20px;">|</div> -->
                <div style="cursor:pointer" @click.stop="shareVip(index)">生成二维码</div>
              </div>
            </div>
            <div class="center" style="height:125px;width:196px;  margin-top: 20px;">
              <img
                style="margin-left:20px;"
                @click="createdVipCard"
                src="../../assets/icon/tjhyk.png"
                alt
              />
            </div>
          </div>
          <div
            v-if="ewm"
            class="img1"
            v-bind:style="{ top: top+'px', left: left + 'px' }"
            style="z-index:3"
          >
            <div ref="courseInfo">
              <span class="shopNameClass">{{this.shopInformation.shopName}}</span>
              <div>
                <canvas id="canvas1"></canvas>
                <img :src="codeIMG" style="width: 100%; height: 100%;" alt />
                <div style="position: absolute;top: 232px;left: 85px;font-size: 1px;">扫码领会员 享<span style="color: red;font-size: 18px;">{{discount}}</span>折</div>
                <el-button type="primary" class="button8" @click="saveImg">保存图片</el-button>
              </div>
            </div>
          </div>
          <!-- <div class="img2">
            <img @click="pages = 3" src="../../assets/icon/hyk4.png" alt />
            <div class="text2" @click="ewm = !ewm">生成二维码</div>
          </div>-->
        </div>
      </div>
      <!-- 会员详情界面 -->
      <div v-if="pages == 3" class="vipDetail">
        <div class="rightHead">
          <div style="margin:0 0 0 25px;font-size:15px;padding-top:16px;color:#707070;">会员管理</div>
        </div>
        <div class="commodityHead" style="height:90px;z-index:100">
          <el-breadcrumb class="elArrowText" separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>
              <a @click="pages = 1, pageNumber = 1" href="javascript:;">会员管理</a>
            </el-breadcrumb-item>
            <el-breadcrumb-item>会员详情</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div style="padding:30px;padding-top: 100px;">
          <div
            class="commodityHead"
            style="position:relative;height:40px;padding:12px 20px 15px 30px;"
          >
            <b>基本资料</b>
          </div>
          <div class="content2">
            <div>
              <div class="alignCenter">
                头像：
                <span class="content2-text">
                  <img
                    style="    height: 40px;width: 40px;margin-left:10px"
                    v-if="vipDetailList.headLogo"
                    :src="vipDetailList.headLogo"
                    alt
                  />
                  <img
                    style="    height: 40px;width: 40px;margin-left:10px"
                    v-else
                    src="../../assets/icon/hytx.png"
                    alt
                  />
                </span>
              </div>
              <div>
                姓名：
                <span class="content2-text">{{vipDetailList.fullName}}</span>
              </div>
              <div>
                性别：
                <span class="content2-text" v-if="vipDetailList.sex == 1">男</span>
                <span class="content2-text" v-if="vipDetailList.sex == 0">女</span>
              </div>
              <div>
                手机：
                <span class="content2-text">{{vipDetailList.phoneNum}}</span>
              </div>
              <div>
                生日：
                <span class="content2-text">{{vipDetailList.birthday}}</span>
              </div>
              <div>
                开卡日期：
                <span class="content2-text">{{vipDetailList.becomeMemberTime}}</span>
              </div>
              <div>
                地区：
                <span
                  class="content2-text"
                >{{vipDetailList.provinceId}} {{vipDetailList.cityId}} {{vipDetailList.districtId}}</span>
              </div>
              <div>
                详情地址：
                <span class="content2-text">{{vipDetailList.remark}}</span>
              </div>
            </div>

            <div>
              <el-button class="button2" @click="editDetail = !editDetail">编辑</el-button>
              <!-- <el-button type="primary" class="button">确定</el-button> -->
            </div>
            <!-- 会员详情开卡弹出层 -->
          </div>
          <div v-if="editDetail" class="obs center">
            <div class="pop">
              <div class="title">
                <div v-if="vip == 1">编辑信息</div>
                <div style="color:gray;font-size:15px;cursor:pointer" @click="editDetail = false">x</div>
              </div>
              <!-- 进度条 -->
              <!-- 填信息 -->
              <div v-if="vip == 1">
                <div id="vipInformation">
                  <!-- 会员信息 -->
                  <div class="content1">会员信息</div>
                  <!-- 表单验证 -->
                  <el-form
                    :model="ruleForm"
                    :rules="rules"
                    ref="ruleForm"
                    label-width="100px"
                    class="demo-ruleForm"
                    hide-required-asterisk
                    label-position="left"
                  >
                    <div style="padding:10px 20px 0 20px;">
                      <el-form-item label="手机号码：" placeholder="输入手机号码">
                        <div style="color:#606266">{{vipDetailList.phoneNum}}</div>
                      </el-form-item>
                      <el-form-item label="会员姓名：" placeholder="输入姓名">
                        <el-input v-model="ruleForm.fullName"></el-input>
                      </el-form-item>
                      <el-form-item label="性别：" prop="sex">
                        <el-radio-group v-model="ruleForm.sex">
                          <el-radio label="男"></el-radio>
                          <el-radio label="女"></el-radio>
                        </el-radio-group>
                      </el-form-item>
                      <el-form-item label="添加会员卡：" prop>
                        <el-select
                          v-model="ruleForm.shopMemberCardId"
                          @change="selectChange(ruleForm.shopMemberCardId,3)"
                          placeholder="未选择"
                        >
                          <el-option
                            v-for="(item,index) in vipList"
                            :label="item.cardName"
                            :value="item.shopMemberCardId"
                            :key="index"
                          ></el-option>
                        </el-select>
                        <div class="isEnable2">
                          <span class="content2-ygq2" v-if="isExpireShow3">已过期</span>
                          <span class="content2-jyz2" v-if="isEnableShow3">禁用中</span>
                        </div>
                      </el-form-item>
                    </div>
                    <div class="content1">完善会员信息（可选）</div>

                    <div style="padding:10px 20px 0 20px;">
                      <el-form-item label="生日" prop>
                        <div class="block">
                          <el-date-picker
                            value-format="yyyy-MM-dd"
                            v-model="ruleForm.birthday"
                            type="date"
                            placeholder="选择日期"
                          ></el-date-picker>
                        </div>
                      </el-form-item>
                      <el-form-item label="地区：" prop>
                        <div class="block">
                          <el-cascader v-model="ruleForm.provinceId" :options="options"></el-cascader>
                        </div>
                      </el-form-item>
                      <el-form-item label="详情地址：" prop placeholder="请输入备注信息">
                        <el-input type="textarea" v-model="ruleForm.remark"></el-input>
                      </el-form-item>
                    </div>
                    <el-form-item style="float:left;padding:0 20px;">
                      <el-button
                        type="primary"
                        class="button"
                        @click="editVipSubmitFrom('ruleForm')"
                      >保存</el-button>
                      <!-- <el-button @click="resetForm('ruleForm')">重置</el-button> -->
                    </el-form-item>
                  </el-form>
                </div>
              </div>
            </div>
          </div>
          <div
            class="commodityHead"
            style="position:relative;margin-top:20px;height:40px;padding:12px 20px 15px 30px;"
          >
            <b>优惠信息</b>
          </div>
          <div class="content2">
            <div>
              优惠券：
              <span class="content2-text">{{vipDetailList.cashCouponCount}}张</span>
            </div>
            <div>
              会员卡-NO.{{vipDetailList.code}}：
              <span class="content2-text">{{vipDetailList.cardName}}</span>
              <span class="content2-ygq" v-if="vipDetailList.isExpire">已过期</span>
              <span class="content2-jyz" v-if="!vipDetailList.isEnable">禁用中</span>
              <el-button type="text" @click="editDetail = !editDetail">更换会员卡</el-button>
            </div>
            <div>
              绑定微信：
              <span class="content2-text" v-if="vipDetailList.isBindWx">已绑定微信</span>
              <span class="content2-text" v-if="!vipDetailList.isBindWx">未绑定微信</span>
              <el-button type="text" @click="bindWX">编辑</el-button>
            </div>
          </div>
          <div
            class="commodityHead"
            style="height:40px;margin-top:20px;padding:12px 20px 15px 30px;position:relative;"
          >
            <b>消费信息</b>
          </div>
          <div class="content2">
            <div>
              账户余额：
              <span class="content2-text">{{vipDetailList.wallet}}元</span>
            </div>
            <div>
              累计积分：
              <span class="content2-text">{{vipDetailList.totalScore}}个</span>
            </div>
            <div>
              累计消费：
              <span class="content2-text">{{vipDetailList.totalConsumeMoney}}元</span>
            </div>
            <div>
              消费次数：
              <span class="content2-text">{{vipDetailList.totalConsumeCount}}笔</span>
            </div>
            <el-button
              type="primary"
              class="button"
              style="margin-top:20px;"
              @click="openVipRecharge"
            >充值</el-button>
          </div>
          <div v-if="vipRecharge" class="obs center">
            <div class="pop">
              <div class="title">
                <div v-if="vip == 1">充值会员</div>

                <div style="color:gray;font-size:15px;cursor:pointer" @click="vipRecharge = false">x</div>
              </div>
              <!-- 充值 -->
              <div class="column center" style="margin-top:40px;">
                <!-- <img src="../../assets/icon/cz.png" style="height:200px;width:340px;" alt /> -->
                <div class="totalVip">
                  <div class="vipCard">
                    <div
                      class="changeColor"
                      v-if="cardColorArr.length !== 0"
                      :style="{background: `linear-gradient(to bottom right, ${vipDetailList.startValue}, ${vipDetailList.endValue}`,height:'200px',width:'340px'}"
                    ></div>

                    <div
                      class="name"
                      :style="{color:vipDetailList.textColor,fontSize:'20px'}"
                    >{{vipDetailList.cardName}}</div>
                    <div
                      class="welcome"
                      style="font-size:16px;margin-top:15px"
                    >{{vipDetailList.cardSlogan}}</div>
                  </div>
                </div>
                <div class="price row alignCenter">
                  <span>充值金额：</span>
                  <div style="width:275px;">
                    <el-input v-model="rechargeNum" placeholder="输入金额" @blur="rechargeNumBlur">12312</el-input>
                  </div>
                </div>
                <div class="money">
                  <div
                    class="button7"
                    v-for="(item,index) in activityList"
                    :key="index"
                  >{{item.rechargeMoney}}元送{{item.handselMoney}}元</div>
                </div>
                <div class="moneyButton">
                  <el-button class="button2" style="width:75px" @click="recharge(1)">现金收款</el-button>
                  <el-button
                    class="button3"
                    style="width:75px"
                    @click="recharge(2)"
                    type="primary"
                  >扫码收款</el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 添加会员卡界面、删除会员卡 -->
      <div v-if="pages == 4" class="vipDetail">
        <div class="rightHead">
          <div style="margin:0 0 0 25px;font-size:15px;padding-top:16px;color:#707070;">会员管理</div>
        </div>
        <div class="commodityHead" style="height:90px;">
          <el-breadcrumb class="elArrowText" separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>
              <a @click="pages = 2" href="javascript:;">会员卡管理</a>
            </el-breadcrumb-item>
            <el-breadcrumb-item v-if="!edit">添加会员卡</el-breadcrumb-item>
            <el-breadcrumb-item v-if="edit">编辑会员卡</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="addVip">
          <div class="vipCard">
            <div
              class="changeColor"
              v-if="cardColorArr.length !== 0"
              :style="{background: `linear-gradient(to bottom right, ${cardColorArr[cardColor].startValue}, ${cardColorArr[cardColor].endValue})`}"
            ></div>
            <!-- <img
              style="position: absolute;top: 14px;left: 15px;"
              src="../../assets/icon/hykbj.png"
              alt
            /> -->
            <img v-if="cardColor=='blue'" src="../../assets/icon/tjhyk2.png" alt />
            <div class="name" :style="{color:textColor}">{{ruleForm2.cardName}}</div>
            <div class="welcome">{{ruleForm2.cardSlogan}}</div>
            <div class="time">有效期：{{ruleForm2.expireType}}</div>
            <div class="discount">
              <span style="font-size:30px;">{{ruleForm2.discount}}</span>折
            </div>
            <!-- <div class="share row center">
              <div>分享会员卡</div>
              <div style="margin-left:20px;">|</div>
              <div>生成二维码</div>
            </div> -->
          </div>
          <div class="addVip-content row alignCenter">
            <div>卡片颜色：</div>
            <div id="pcikColor" class="pcikColor center">
              <el-popover placement="right" width="265" trigger="click" v-model="visible">
                <div class="row">
                  <div
                    v-for="(item,index) in cardColorArr"
                    :key="index"
                    class="square"
                    @click="fromColor = item,cardColor = index,smallColor=item.endValue,textColor = item.textColor"
                    :style="{background:item.endValue}"
                  ></div>
                </div>
                <div class="small" :style="{background:smallColor}" slot="reference"></div>
              </el-popover>
            </div>
          </div>
          <div class="addVip-content alignCenter">
            <el-form
              :model="ruleForm2"
              :rules="rules2"
              ref="ruleForm2"
              label-width="100px"
              class="demo-ruleForm"
              hide-required-asterisk
              label-position="left"
            >
              <el-form-item label="会员名称：" prop="cardName">
                <el-input
                  v-model="ruleForm2.cardName"
                  autofocus="true"
                  placeholder="请输入会员卡名称"
                  class="input1"
                ></el-input>
              </el-form-item>
              <el-form-item label="会员标语：" prop="cardSlogan">
                <el-input v-model="ruleForm2.cardSlogan" placeholder="请输入会员标语"></el-input>
              </el-form-item>
              <el-form-item label="会员折扣：" prop="discount">
                <el-input
                  type="number"
                  v-model.number="ruleForm2.discount"
                  placeholder="请正确输入如：8.8"
                  class="input2"
                ></el-input>
              </el-form-item>
              <el-form-item label="有效日期：" prop="expireType">
                <el-select v-model="ruleForm2.expireType" placeholder="永久/按天/按时间" class="input2">
                  <el-option label="永久" value="永久"></el-option>
                  <el-option label="按天" value="按天"></el-option>
                  <el-option label="按时间" value="按时间"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item v-if="ruleForm2.expireType == '按天'" label prop="day">
                <el-input v-model.number="ruleForm2.day" placeholder="输入天数" class="input2"></el-input>
              </el-form-item>
              <el-form-item v-if="ruleForm2.expireType == '按时间'" label prop="time">
                <el-date-picker
                  v-model="ruleForm2.time"
                  type="daterange"
                  size="small"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="联系号码：" prop="servicePhone">
                <el-input v-model="ruleForm2.servicePhone" placeholder="输入联系号码" class="input2"></el-input>
              </el-form-item>
              <el-form-item label="默认会员卡：" prop="">
                <el-switch v-model="ruleForm2.isDefault" />
              </el-form-item>
              <el-form-item label="使用状态：" prop="resource">
                <el-radio-group v-model="ruleForm2.isEnable">
                  <el-radio label="启用" checked></el-radio>
                  <el-radio label="停用"></el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="积分功能：" prop="integralSwitch">
                <el-switch v-model="ruleForm2.integralSwitch" />
                <!-- <div v-if="ruleForm2.integralSwitch == true">
                  <span class="pr5">消费</span>
                  <el-input placeholder="请输入消费金额" style="width:200px;" v-model="ruleForm2.fullConsume" class="pr5"/>
                  <span class="pr5">送</span>
                  <el-input class="pr5" placeholder="请输入积分" style="width:200px;" v-model="ruleForm2.integral" />积分</div> -->
                <div v-show="ruleForm2.integralSwitch == true">
                  <el-select v-model="integralValue" @change="integralValueChange" placeholder="请选择">
                    <el-option
                      v-for="item in integralList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </div>
              </el-form-item>
              <el-form-item label="会员等级">
                <el-switch v-model="ruleForm2.highSwitch" />
                <div v-if="ruleForm2.highSwitch == true">
                  <el-select v-model="memberLevel" @change="memberLevelChange" placeholder="请选择">
                    <el-option
                      v-for="item in memberLevelList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                  <div>
                    <el-input v-model="ruleForm2.cumulateConsumeCount" placeholder="请输入累计成功消费笔数" class="input1"></el-input>
                    <el-input v-model="ruleForm2.cumulateConsumeMoney" placeholder="请输入累计消费金额" class="input1"></el-input>
                    <el-input v-model="ruleForm2.cumulateScore" placeholder="请输入累计达到积分" class="input1"></el-input>
                  </div>
                </div>
              </el-form-item>
              <el-form-item label="使用须知：" prop="useNotice">
                <el-input type="textarea" v-model="ruleForm2.useNotice" placeholder="补充信息以便会员知晓"></el-input>
              </el-form-item>
              <!-- <div class="row alignCenter">
                <el-form-item label="支付后可取">
                  <el-switch value="123" v-model="ruleForm2.openReceiveInYSC"></el-switch>
                </el-form-item>
                <el-form-item id="customerSwitch" label="易城市APP可领取">
                  <el-switch v-model="ruleForm2.openReceiveAfterPay"></el-switch>
                </el-form-item>
                <div
                  style="height:40px;margin-left:20px;color:gray"
                >提示：会员卡将同步至易城市APP供消费者自助领取，吸引客户到店消费</div>
              </div> -->
              <el-form-item>
                <el-button
                  type="primary"
                  v-if="!edit"
                  class="button"
                  @click="cardSubmitForm('ruleForm2')"
                >保存</el-button>
                <el-button
                  type="primary"
                  v-if="edit"
                  class="button"
                  @click="cardSubmitForm2('ruleForm2')"
                >保存</el-button>
                <!-- <el-button v-if="edit" @click="resetForm('ruleForm2')" class="button2">停用</el-button> -->
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <el-dialog
        title="选择优惠券"
        :visible.sync="dialogVisible"
        width="25%">
        <div style="height:280px">
          <el-select v-model="checkedId" placeholder="请选择">
            <el-option
              v-for="item in couponList"
              :key="item.id"
              :label="item.title"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="confirm_sendCoupon">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { shopMemberActivityList, toShopMemberTableTags, getCashCouponList, sendCashCoupon, removeShopMember} from "../api";

import cityArr from "../../assets/citys.json";
import cityData from "../../assets/cityData.json";
import cityData2 from "../../assets/cityData2.json";

import codeIMG from '@/assets/icon/bctps.png';

import html2canvas from 'html2canvas';

import QRCode from 'qrcode'
export default {
  data() {
    var checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("手机号不能为空"));
      } else {
        const reg = /^1[3|4|5|7|8][0-9]\d{8}$/;
        console.log(reg.test(value));
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error("请输入正确的手机号"));
        }
      }
    };
    var checkeDay = (rule, value, callback) => {
      if (this.ruleForm2.expireType !== "永久") {
        if (!value) {
          return callback(new Error("天数不能为空"));
        } else if (typeof value !== "number") {
          return callback(new Error("请输入数字"));
        } else {
          return callback();
        }
      } else {
        return callback();
      }
    };
    var checkDiscount = (rule, value, callback) => {
      if (value.length > 3 || value.length < 1) {
        return callback(new Error("请正确输入如：8.8"));
      } else if (typeof value !== "number") {
        return callback(new Error("请输入数字"));
      } else if (Number(value) > 10) {
        return callback(new Error("请正确输入如：8.8"));
      }else {
        return callback();
      }
    };
    return {
	  opNickName:'',
      couponList: [],
      checkedId: "",
      dialogVisible: false,
      integralValue: "",
      integralList: [
        {
          value: '1',
          label: '消费1元送1个积分'
        },
        {
          value: '10',
          label: '消费1元送10个积分'
        },
        {
          value: '100',
          label: '消费1元送100个积分'
        },
      ],
      memberLevelList: [
        { value: '1', label: '1' },
        { value: '2', label: '2' },
        { value: '3', label: '3' },
        { value: '4', label: '4' },
        { value: '5', label: '5' },
        { value: '6', label: '6' },
        { value: '7', label: '7' },
        { value: '8', label: '8' },
        { value: '9', label: '9' },
        { value: '10', label: '10' },
      ],
      memberLevel: "",
      codeIMG: codeIMG,
      isExpireShow: false,
      isEnableShow: false,
      isExpireShow2: false,
      isEnableShow2: false,
      isExpireShow3: false,
      isEnableShow3: false,
      temporaryStorage: ["1", "1", 1], //测试数据
      upLoadVip: "", //批量上传会员的id
      loading: false,
      vipRecharge: false,
      vipRecharge2: false,
      editDetail: false,
      edit: false,
      isShow: false, //编辑按钮显隐
      elMain: {
        background: "linear-gradient(to right, #cdcdd7 , #adb3b9)"
      },
      shopMemberCardId: "", //修改会员卡的id
      smallColor: "",
      textColor: "",
      cardColorArr: [], //会员卡颜色数组
      //添加会员卡的卡片颜色
      cardColor: 0,
      //添加会员卡的选择卡片颜色pop
      visible: false,
      fromColor: "", //选择卡片的色值
      //添加会员卡的表单验证
      ruleForm2: {
        cardName: "",
        cardSlogan: "",
        discount: "",
        expireType: "",
        servicePhone: "",
        expireDayNum: "",
        cardBackGroup: "",
        useNotice: "",
        isEnable: "启用",
        openReceiveAfterPay: false,
        openReceiveInYSC: false,
        integralSwitch: false,
        fullConsume: "",
        integral: "",
        day: "",
        time: "",
        highSwitch: false,
        cumulateConsumeCount: "",
        cumulateConsumeMoney: "",
        cumulateScore: "",
        isDefault: false
      },
      pageNumber: 1,
      pagesize: 20,
      rules2: {
        cardName: [
          { required: true, message: "请输入卡片名称", trigger: "blur" },
          { min: 1, max: 11, message: "长度在 1 到 11 个字符", trigger: "blur" }
        ],
        cardSlogan: [
          { required: true, message: "请输入卡片标语", trigger: "blur" },
          { min: 1, max: 9, message: "长度在 1 到 9 个字符", trigger: "blur" }
        ],
        discount: [{ validator: checkDiscount, trigger: "blur" }],
        expireType: [
          { required: true, message: "请选择日期", trigger: "blur" }
        ],
        time: [{ required: true, message: "请选择日期", trigger: "blur" }],
        servicePhone: [
          { required: true, message: "请输入客户电话", trigger: "blur" },
          { validator: checkPhone, trigger: "blur" }
        ],
        day: [{ validator: checkeDay, trigger: "blur" }],
        useNotice: [
          { required: true, message: "请输入使用须知", trigger: "change" }
        ],
        desc: [{ required: true, message: "请填写活动形式", trigger: "blur" }],
        integralSwitch: [ { required: true, message: "请选择是否开起积分功能", trigger: "change" } ],
        fullConsume: [{ required: true, message: "请填写消费金额", trigger: "blur" }]
      },
      // 个人信息数组
      arr: [
        {
          num: 5,
          sonsume: 5,
          balance: 6432,
          wx: "未绑定",
          vipId: "NO:83928",
          coupon: 2,
          location: "温州",
          statrData: "1993.3.2",
          birthday: "1993.3.2",
          phone: "12353563231",
          name: "张晓晓",
          gender: "男"
        }
      ],
      // 控制二维码的显隐
      ewm: false,
      //控制保存二维码的绝对定位
      top: 225,
      left: 275,
      //pages=1客户管理页面，pages=2会员卡管理界面，pages=3会员详情界面，pages=4添加会员卡界面
      pages: 1,
      // 控制开卡弹出层第几页
      vip: 1,
      //控制开卡弹出层
      isPop: false,
      vipList: [], //会员卡列表
      // 表单验证
      ruleForm: {
        fullName: "", //姓名
        phoneNum: "", //手机号码
        sex: "男", //性别
        shopMemberCardId: "", //会员卡ID
        //完善 的信息 可选
        birthday: "", //生日 [可选]
        //地区 [可选]
        provinceId: "", //省 [可选]
        cityId: "", //    市[可选]
        districtId: "", // 区县 [可选]
        remark: "" //备注
      },

      // 表单验证规则
      rules: {
        fullName: [
          {
            required: true,
            max: 6,
            message: "请输入1-6位会员名",
            trigger: "blur"
          }
        ],
        sex: [{ required: true, message: " ", trigger: "blur" }],
        date1: [
          {
            type: "date",
            required: true,
            message: " ",
            trigger: "change"
          }
        ],
        date2: [
          {
            type: "date",
            required: true,
            message: " ",
            trigger: "change"
          }
        ],
        type: [
          {
            type: "array",
            required: true,
            message: " ",
            trigger: "change"
          }
        ],
        resource: [{ required: true, message: " ", trigger: "change" }],
        desc: [{ required: true, message: " ", trigger: "blur" }]
      },
      // 表格
      tableData: [],
      userList: "",
      shopInformation: "",
      cityData2: [], //区县数组
      cityData1: [], //省份数组
      cityData3: [], //城市数组
      value: "",
      totalCount: "",
      vipDetailList: [],
      shopMemberId: "",
      shopMemberId2: "",
      rechargeNum: "",
      codeMsg: "", //扫码枪数据
      playCode: false,
      popShopMemberCardId: "", //开卡时的会员卡id
      popVipCard: "",
      activityList: "",
      options: "",
      optionsData: [1, 1, 1],
      pageVal: 1, //分页当前页
      codeUrl: "",
      qrCodeUrl: "",
      shopMemberCardIds: "",
      discount: "",
      disabled: false,
      professionList: [
        { value: '', label: '全部职业' },
        { value: '教师', label: '教师' }, 
        { value: '工人', label: '工人' }, 
        { value: '记者', label: '记者' }, 
        { value: '厨师', label: '厨师' }, 
        { value: '医生', label: '医生' }, 
        { value: '护士', label: '护士' }, 
        { value: '司机', label: '司机' }, 
        { value: '律师', label: '律师' }, 
        { value: '商人', label: '商人' }, 
        { value: '导游', label: '导游' }, 
        { value: '裁缝', label: '裁缝' }, 
        { value: '公务员', label: '公务员' }, 
        { value: '个体户', label: '个体户' }
      ],
      profession: "",
      shopName: "",
      lastBirthdayDay: "",
      lastActiveDay: "",
      shopMemberIds: [],
      checkAll: false,
      shopMemberIds1: "",
      isSingle: "",
      shopMemberIds2: ""
    };
  },

  computed: {},

  watch: {
    codeMsg: function(oldValue, newValue) {
      console.log(this.codeMsg, "code改变");
      if (this.codeMsg.length == 18) {
        this.Pay_userPayScan();
        document.onkeydown = "";
      }
    },
    pages: function() {
      this.ShopMember_shopMemberPager(); //店铺会员列表
      this.ruleForm = {
        fullName: "", //姓名
        phoneNum: "", //手机号码
        sex: "男", //性别
        shopMemberCardId: "", //会员卡ID
        //完善 的信息 可选
        birthday: "", //生日 [可选]
        //地区 [可选]
        provinceId: "", //省 [可选]
        cityId: "", //    市[可选]
        districtId: "", // 区县 [可选]
        remark: "" //备注
      };
    }
  },

  created() {
    var a = {
      userId: this.userList.id, //用户Id
      sessionId: this.userList.sessionId
    };

    for (let i in cityData) {
      this.cityData1.push(cityData[i]);
      for (let a in cityData[i].sub) {
        this.cityData3.push(cityData[i].sub[a]);
        for (let e in cityData[i].sub[a].sub) {
          this.cityData2.push(cityData[i].sub[a].sub[e]);
        }
      }
    }
    let userList = JSON.parse(this.getCookie("userList"));
    this.userList = userList;
    let shopInformation = JSON.parse(this.getCookie("shopInformation"));
    this.shopInformation = shopInformation;
    console.log(this.shopInformation, "this.shopInformation")
    console.log(this.$route.query.docId, "router");
    if (this.$route.query.docId === true) {
      this.open();
    } else if (this.$route.query.docId === "2") {
      this.pages = 2;
    }
    this.request
      .post("qrcapi/ShopMemberCard_getCardColors", {
        userId: this.userList.id, //用户Id
        sessionId: this.userList.sessionId
      })
      .then(res => {
        console.log(res, "会员卡颜色");
        this.cardColorArr = res.data;
        this.smallColor = res.data[0].startValue;
        this.textColor = res.data[0].textColor;
        this.fromColor = res.data[0];
      });

    this.ShopMemberCard_shopMemberCardList(); //会员列表
    this.ShopMember_shopMemberPager("", 1, "", "", "", "", 20); //店铺会员列表
    console.log(cityData2, "cityData2cityData2cityData2");
    this.options = cityData2;
    // this.toImage()
    
  },

  destroyed() {
    localStorage.removeItem("phoneNumber")
  },

  methods: {
    handleSelectionChange(row) {
      this.shopMemberIds = []
      this.shopMemberIds2 = ""
      row.forEach(item => {
        this.shopMemberIds.unshift(item.shopMemberId)
      })
      localStorage.setItem("shopMemberIds", JSON.stringify(this.shopMemberIds))

      row.forEach(item => {
        this.shopMemberIds2 += ',' + item.shopMemberId + ','
        this.shopMemberIds2 = this.shopMemberIds2.substring(0, this.shopMemberIds2.lastIndexOf(','))
      })
      if (this.shopMemberIds2.substr(0,1)==',')  this.shopMemberIds2 = this.shopMemberIds2.substr(1);
    },
    rowKey(row) {
      return row.shopMemberId
    },
    // 一键发券
    send_coupon() {
      this.dialogVisible = true
      this.isSingle = 1
    },
    // 单个发券
    confirm_sendCoupon() {
      console.log(this.isSingle, "isSingle")
      console.log(this.checkedId, "cashCouponBatchOrderId")
      console.log(this.shopMemberIds2, "shopMemberIds2")
      // return
      if (this.isSingle == 1) {
        sendCashCoupon({
          userId: this.userList.id, //用户Id
          sessionId: this.userList.sessionId,
          shopMemberIds: this.shopMemberIds2,
          cashCouponBatchOrderId: this.checkedId
        })
        .then(res => {
          this.dialogVisible = false
          this.isSingle = ""
          this.shopMemberIds2 = ""
          this.checkedId = ""
          localStorage.removeItem("shopMemberIds")
          this.ShopMember_shopMemberPager("", 1, "", "", "", "", 20);
          if (res.code == 1) {
            this.$message.success(res.msg)
          } else {
            this.$message.success(res.msg)
          }
        })
        return
      }
      // sendCashCoupon  shopMemberIds  cashCouponBatchOrderId
      sendCashCoupon({
        userId: this.userList.id, //用户Id
        sessionId: this.userList.sessionId,
        shopMemberIds: this.shopMemberIds1,
        cashCouponBatchOrderId: this.checkedId
      })
      .then(res => {
        this.dialogVisible = false
        this.ShopMember_shopMemberPager("", 1, "", "", "", "", 20);
        this.checkedId = ""
        if (res.code == 1) {
          this.$message.success(res.msg)
        } else {
          this.$message.success(res.msg)
        }
      })
    },
    single_sendCoupon(shopMemberId) {
      this.shopMemberIds1 = shopMemberId
      this.dialogVisible = true
    },
    delete_memeber(row) {
      this.$confirm("您确定要删除该会员吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
      .then(() => {
          removeShopMember({
            userId: this.userList.id, //用户Id
            sessionId: this.userList.sessionId,
            shopMemberId: row.shopMemberId
          }).then(res => {
              if (res.code == 1) {
                this.$message.success('删除成功');
                this.ShopMember_shopMemberPager("", this.pageNumber, "", "", "", "", 20);
              } else {
                this.$message.error(res.msg);
              }
          });
      })
      .catch(() => {});
    },
    // 获取优惠券列表
    getCashCouponList() {
      getCashCouponList({
        userId: this.userList.id, //用户Id
        sessionId: this.userList.sessionId,
        pageNumber: 1,
        isEnable: 1,
        batchOrderType: 0
      })
      .then(res => {
        if (res.code == 1) {
          var timestamp = Date.parse(new Date());
          var newList = res.data.pager.list.filter(item => {
            var time3 = Date.parse(item.expireDay);
            return timestamp - time3 <= 86400
          })
          this.couponList = newList
        } else if (res.code == -1) {
          this.couponList = []
        } else if (res.code == 2) {
          this.$message.error(res.msg);
          this.$router.push("/");
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    saveImg() {
      html2canvas(this.$refs.courseInfo, {
      }).then(canvas => {
        let link = document.createElement("a");
        link.href = canvas.toDataURL();//下载链接
        link.setAttribute("download","qrcode.png");
        link.style.display = "none";//a标签隐藏
        document.body.appendChild(link);
        link.click();
      });
    },
    useqrcode(qrCodeUrl) {
      this.QueryDetail = qrCodeUrl
      console.log(this.QueryDetail, "this.QueryDetail")
      var canvas = document.getElementById("canvas")
      QRCode.toCanvas(canvas, this.QueryDetail, function (error) {
        if (error) console.error(error)
        console.log("success");
      })
    },
    newqrcode(qrCodeUrl){ 
      //生成的二维码内容，可以添加变量
      this.QueryDetail = "https://api.yichengshi.cn" + "/shopMemberCard/" + this.shopMemberCardIds + '.html';
      console.log(this.QueryDetail, "this.QueryDetail")
      var canvas = document.getElementById("canvas1")
      QRCode.toCanvas(canvas, this.QueryDetail, function (error) {
        if (error) console.error(error)
        console.log("success");
      })
    },
    bindWX() {
      this.request
      .post("qrcapi/ShopMember_oldShopMemberBindWxCode", {
        sessionId: this.userList.sessionId,
        userId: this.userList.id,
        shopMemberId: this.shopMemberId, //会员卡ID
      })
      .then(res => {
        console.log(res, "获取二维码内容")
        setTimeout( () => {
          this.useqrcode(res.data.qrCode)  // 此为绘画canvas的方法调用
        }, 0)
        this.isPop = true
        this.pages = 1 
        this.vip = 2
        this.pageNumber = 1
		this.mpNickName = res.data.mpNickName
      })
    },
    selectChange(e, type) {
      // type = 1 首页下拉框 type = 2 首页开卡 type = 3 详情页开卡
      console.log("change", e);
      if (type == 1) {
        var a = this.upLoadVip;
      } else {
        var a = this.ruleForm.shopMemberCardId;
      }
      for (let i of this.vipList) {
        if (i.shopMemberCardId == a) {
          if (i.isEnable == 0) {
            if (type == 1) {
              this.isEnableShow = true;
            } else if (type == 2) {
              this.isEnableShow2 = true;
            } else {
              this.isEnableShow3 = true;
            }
          } else {
            if (type == 1) {
              this.isEnableShow = false;
            } else if (type == 2) {
              this.isEnableShow2 = false;
            } else {
              this.isEnableShow3 = false;
            }
          }

          if (i.isExpire == 1) {
            if (type == 1) {
              this.isExpireShow = true;
            } else if (type == 2) {
              this.isExpireShow2 = true;
            } else {
              this.isExpireShow3 = true;
            }
          } else {
            if (type == 1) {
              this.isExpireShow = false;
            } else if (type == 2) {
              this.isExpireShow2 = false;
            } else {
              this.isExpireShow3 = false;
            }
          }
        }
      }
    },
    showtemporaryStorage() {
      console.log(this.temporaryStorage);
    },
    openVipRecharge() {
      this.vipRecharge = true;
      this.shopMemberActivityList(this.vipDetailList.shopMemberCardId);
    },
    openVipRecharge2(id) {
      this.vipDetail(id);
      this.vipRecharge2 = true;

      console.log("chongzhi");
    },
    goPay() {
      this.vip = 3;
      this.findShopMemberCard(this.popShopMemberCardId);
      this.shopMemberActivityList(this.popShopMemberCardId); //查询活动列表
    },
    findShopMemberCard(shopMemberCardId) {
      this.request
        .post("qrcapi/ShopMemberCard_findShopMemberCard", {
          userId: this.userList.id, //用户Id
          sessionId: this.userList.sessionId,
          // shopMemberCardId: this.shopMemberId
          shopMemberCardId: shopMemberCardId
        })
        .then(res => {
          console.log(res, "pop");
          if (res.code == 1) {
            this.popVipCard = res.data;
            // this.$message({
            //   type: "success",
            //   message: res.msg
            // });
          } else if (res.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    keySay(b) {},
    //支付
    Pay_userPayScan() {
      this.request
        .post("qrcapi/Pay_userPayScan", {
          userId: this.userList.id, //用户Id
          sessionId: this.userList.sessionId,
          mallOrderId: this.mallOrderId, //订单id
          auth_code: this.codeMsg //收款码
        })
        .then(res => {
          this.pages = 1;
          this.vipRecharge = false;
          this.vipRecharge2 = false;
          this.loading = false;
          this.isPop = false;
          console.log(res, "shopMemberActivityList");
          if (res.code == 1) {
            // this.$message({
            //   type: "success",
            //   message: res.msg
            // });
          } else if (res.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    //查询活动列表
    shopMemberActivityList(shopMemberCardId) {
      this.request
        .post("qrcapi/ShopMemberActivity_shopMemberActivityList", {
          userId: this.userList.id, //用户Id
          sessionId: this.userList.sessionId,
          shopMemberCardId: shopMemberCardId
        })
        .then(res => {
          console.log(res, "shopMemberActivityList");
          if (res.code == 1) {
            // var list = res.data[0].shopMemberCardIds.split(',')
            this.activityList = JSON.parse(res.data[0].itemContent);
            console.log(this.activityList, "22");
          } else if (res.code == -1) {
            this.activityList = "";
          } else if (res.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else if (res.code == 2) {
            this.$message.error(res.msg);
          } else {
          }
        });
    },
    //创建会员卡
    createdVipCard() {
      this.pages = 4;
      this.edit = false;
      this.ruleForm2 = {
        cardName: "",
        cardSlogan: "",
        discount: "",
        expireType: "",
        servicePhone: "",
        expireDayNum: "",
        cardBackGroup: "",
        useNotice: "",
        isEnable: "启用",
        openReceiveAfterPay: false,
        openReceiveInYSC: false,
        day: "",
        time: ""
      };
    },
    //编辑会员卡
    editVipCard(e) {
      console.log(e, 1111)
      this.pages = 4;
      this.edit = true;
      this.shopMemberCardId = e;
      var ruleForm2 = this.ruleForm2;
      var isEnable,
      highSwitch,
      cumulateConsumeCount,
      cumulateConsumeMoney,
      cumulateScore,
      isDefault;
      if (e.isEnable == 1) {
        isEnable = "启用";
      } else {
        isEnable = "停用";
      }
      var openReceiveAfterPay;
      if (e.openReceiveAfterPay == 1) {
        openReceiveAfterPay = true;
      } else {
        openReceiveAfterPay = false;
      }
      var openReceiveInYSC;
      if (e.openReceiveInYSC == 1) {
        openReceiveInYSC = true;
      } else {
        openReceiveInYSC = false;
      }
      var expireType;
      var time = [];
      if (e.expireType == "0") {
        expireType = "永久";
      } else if (e.expireType == "1") {
        expireType = "按天";
      } else {
        expireType = "按时间";
        time[0] = e.startTime;
        time[1] = e.endTime;
      }
      var integralSwitch;
      var fullConsume;
      var integral;
      if (e.integralSwitch == 1) {
        integralSwitch = true
        console.log(e.integral, "e.integral")
        if (e.integral == 1) {
          this.integralValue = "消费1元送1个积分"
        } else if (e.integral == 10) {
          this.integralValue = "消费1元送10个积分"
        } else if (e.integral == 100) {
          this.integralValue = "消费1元送100个积分"
        } else {
          this.integralValue = ""
        }
      } else {
        integralSwitch = false
      }
      if (e.highSwitch == 1) {
        highSwitch = true
        cumulateConsumeCount = e.cumulateConsumeCount
        cumulateConsumeMoney = e.cumulateConsumeMoney
        cumulateScore = e.cumulateScore
        this.memberLevel = e.cardLevel
      } else {
        this.ruleForm2.highSwitch = false
      }
      if (e.isDefault == 1) {
        isDefault = true
      } else {
        isDefault = false
      }
      this.ruleForm2 = {
        cardName: e.cardName,
        cardSlogan: e.cardSlogan,
        discount: Number(e.discount),
        expireType: expireType,
        servicePhone: e.servicePhone,
        expireDayNum: e.expireDayNum,
        cardBackGroup: e.cardBackGroup,
        useNotice: e.useNotice,
        isEnable: isEnable,
        openReceiveAfterPay: openReceiveAfterPay,
        openReceiveInYSC: openReceiveInYSC,
        day: e.expireDayNum,
        time: time,
        integralSwitch: integralSwitch,
        highSwitch: highSwitch,
        cumulateConsumeCount: cumulateConsumeCount,
        cumulateConsumeMoney: cumulateConsumeMoney,
        cumulateScore: cumulateScore,
        memberLevel: this.memberLevel,
        isDefault: isDefault
        // fullConsume: fullConsume,
        // integral: integral
      };
      // this.fromColor = {

      //   shopMemberCardColorId:  e.shopMemberCardColorId, //配色ID
      //   startValue:e.startValue, //渐变开始值 #FFFFFF
      //   endValue: e.endValue, //渐变结束值 #FFFFFF
      //   textColor:e.textColor , //文字颜色#FFFFFF
      // };
      this.request
        .post("qrcapi/ShopMemberCard_getCardColors", {
          userId: this.userList.id, //用户Id
          sessionId: this.userList.sessionId
        })
        .then(res => {
          for (let i in res.data) {
            if (res.data[i].shopMemberCardColorId == e.shopMemberCardColorId) {
              this.cardColor = i;
              this.smallColor = res.data[i].endValue;
              this.textColor = res.data[i].textColor;
            }
          }
        });

      console.log(e, "item");
    },
    rechargeNumBlur(e) {
      let reg = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/
      if (!reg.test(e.target.value)) {
        this.rechargeNum = ""
        this.$message.error("请输入正确的充值金额")
      } else {
        this.rechargeNum = Number(e.target.value)
      }
    },
    //会员充值
    recharge(e) {
      if (e == 1) {
        console.log("调用会员充值");
        this.$confirm("确认充值会员卡吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            this.request
              .post("qrcapi/ShopMember_shopMemberRecharge", {
                userId: this.userList.id, //用户Id
                sessionId: this.userList.sessionId,
                shopMemberId: this.shopMemberId, //会员id
                payMoney: this.rechargeNum, //消费金额
                // payMoney: 0.01, //消费金额
                orderCategory: 8, //订单类型   1,"系统代收款"  2,"店铺收银"  3,"外卖订单"  4,"秒杀订单"  5,"点餐订单"  6,"线下订单"  7,"线上订单"  8,"会员卡订单"  9,"缴费账单
                shopStoreId: this.shopInformation.shopStoreId, //门店ID
                receiptType: e //付款类型   1 现金收款 2扫码收款
              })
              .then(res => {
                if (res.code == 1) {
                  this.isPop = false;
                  this.rechargeNum = ""
                  if (e == 2) {
                    this.playCode = true;
                    var _this = this;
                    document.onkeydown = function(e) {
                      console.log(e, "onkeydown");
                      if (_this.codeMsg.length == 18 && e.key != "Enter") {
                        _this.codeMsg = "";
                      }
                      if (e.key != "Enter") {
                        _this.codeMsg += e.key;
                      }
                    };
                    this.loading = true;
                  } else {
                    this.vipRecharge = false;
                    this.vipRecharge2 = false;
                  }
                  this.ShopMember_shopMemberPager("", this.pageVal); //会员列表
                  this.pages = 1;
                  this.pageNumber = this.pageVal
                  this.mallOrderId = res.data.mallOrderId;
                  // this.vipDetail(this.shopMemberId); //会员详情页
                } else if (res.code == 2) {
                  this.$message.error(res.msg);
                  this.$router.push("/");
                } else {
                  this.$message.error(res.msg);
                }
              });
          })
          .catch(() => {
            // this.$message({
            //   type: "info",
            //   message: "已取消删除"
            // });
          });
      } else {
        if (this.rechargeNum == "") {
          return
        }
        this.request
          .post("qrcapi/ShopMember_shopMemberRecharge", {
            userId: this.userList.id, //用户Id
            sessionId: this.userList.sessionId,
            shopMemberId: this.shopMemberId, //会员id
            payMoney: this.rechargeNum, //消费金额
            // payMoney: 0.01, //消费金额
            orderCategory: 8, //订单类型   1,"系统代收款"  2,"店铺收银"  3,"外卖订单"  4,"秒杀订单"  5,"点餐订单"  6,"线下订单"  7,"线上订单"  8,"会员卡订单"  9,"缴费账单
            shopStoreId: this.shopInformation.shopStoreId, //门店ID
            receiptType: e //付款类型   1 现金收款 2扫码收款
          })
          .then(res => {
            if (res.code == 1) {
              this.isPop = false;
              this.rechargeNum = ""
              if (e == 2) {
                this.playCode = true;
                var _this = this;
                document.onkeydown = function(e) {
                  console.log(e, "onkeydown");
                  var b;
                  if (_this.codeMsg.length == 18 && e.key != "Enter") {
                    _this.codeMsg = "";
                  }
                  if (e.key != "Enter") {
                    _this.codeMsg += e.key;
                  }
                };
                this.loading = true;
              } else {
                this.vipRecharge = false;
                this.vipRecharge2 = false;
              }
              this.ShopMember_shopMemberPager("", this.pageVal); //会员列表
              this.pages = 1;
              this.mallOrderId = res.data.mallOrderId;
              // this.vipDetail(this.shopMemberId); //会员详情页
            } else if (res.code == 2) {
              this.$message.error(res.msg);
              this.$router.push("/");
            } else {
              this.$message.error(res.msg);
            }
          });
      }
    },
    //搜索
    search() {
      var phoneNumber = this.value.trim();
      this.pageNumber = 1
      localStorage.setItem("phoneNumber", phoneNumber)
      this.ShopMember_shopMemberPager(phoneNumber, 1, this.shopName, this.profession, this.lastBirthdayDay, this.lastActiveDay);
      this.$refs.multipleTable.clearSelection();
      localStorage.removeItem("shopMemberIds")
    },
    phoneNumberBlur(e) {
      if (e.target.value.length == 0) {
        localStorage.removeItem("phoneNumber")
      }
    },
    handleAvatarSuccess2(res) {
      if (this.upLoadVip) {
        console.log(res.file);
        var sessionId = this.userList.sessionId;
        var userId = this.userList.id;
        let imgUploadForm = new FormData();
        imgUploadForm.append("file", res.file);
        // imgUploadForm.append("fileContentType", res.file.type);
        // imgUploadForm.append("fileFileName", res.file.name);
        imgUploadForm.append("shopMemberCardId", this.upLoadVip);
        imgUploadForm.append("userId", userId);
        imgUploadForm.append("sessionId", sessionId);
        console.log(imgUploadForm, "1");
        // this.Goods_importGoodsNum(imgUploadForm)
        toShopMemberTableTags(imgUploadForm)
          .then(res => {
            console.log(res, "ffod");
            if (res.data.code == 1) {
              this.$message({
                message: res.data.msg,
                type: "success"
              });
              this.ShopMember_shopMemberPager("", this.pageVal);
            } else if (res.code == 2) {
              this.$message.error(res.data.msg);
              this.$router.push("/");
            } else {
              // this.$message.error(res.data.msg);
              this.$notify({
                title: "警告",
                message: res.data.msg,
                type: 'warning',
                duration: 0
              });
            }
          })
          .catch(res => {
            console.log("error");
          });
      } else {
        this.$message.error("请先选择会员卡");
      }
    },
    //店铺会员列表
    ShopMember_shopMemberPager(phoneNum, pageNumber, shopName, profession, lastBirthdayDay, lastActiveDay, pageSize) {
      this.request
        .post("qrcapi/ShopMember_shopMemberPager", {
          userId: this.userList.id, //用户Id
          sessionId: this.userList.sessionId,
          phoneNum: phoneNum, //电话号码
          pageNumber: pageNumber, //页码
          pageSize: pageSize ? pageSize : 20, //每页记录数
          shopName: shopName,
          profession: profession,
          lastBirthdayDay: lastBirthdayDay,
          lastActiveDay: lastActiveDay
        })
        .then(res => {
          if (res.code == 1) {
            this.tableData = res.data.pager;
            this.totalCount = res.data.pager.totalCount;
            // this.$message({
            //   type: "success",
            //   message: res.msg
            // });
            this.getCashCouponList()
            var shopMemberId1 = JSON.parse(localStorage.getItem("shopMemberIds") || "[]");
            console.log(shopMemberId1, "shopMemberIds")
            this.$nextTick(function() {
              this.tableData.list.forEach(row => {
                if (shopMemberId1.includes(row.shopMemberId)) {
                  this.$refs.multipleTable.toggleRowSelection(row, true);
                }
              });
            });
          } else if (res.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            this.$message.error(res.msg);
          }

          console.log(res, "店铺会员列表");
        });
    },
    //会员详情页
    vipDetail(shopMemberId, isGo, shopMemberCardId) {
      console.log(shopMemberId, isGo, shopMemberCardId, "shopMemberId")
      this.popShopMemberCardId = shopMemberCardId
      this.shopMemberId = shopMemberId
      if (isGo) {
        this.pages = 3;
      }
      this.request
        .post("qrcapi/ShopMember_findShopMember", {
          userId: this.userList.id, //用户Id
          sessionId: this.userList.sessionId,
          shopMemberId: shopMemberId
        })
        .then(res => {
          console.log(res, "123");
          if (res.code == 1) {
            //根据id查省市区
            var cityData2 = this.cityData2; //区县数组
            var cityData1 = this.cityData1; //省份数组
            var cityData3 = this.cityData3; //城市数组
            var provinceId = res.data.provinceId; //省
            var cityId = res.data.cityId; //市
            var districtId = res.data.districtId; //区
            var a, b, c;
            for (let i in cityData2) {
              if (cityData2[i].value == districtId) {
                a = cityData2[i].name;
              }
            }
            for (let i in cityData3) {
              if (cityData3[i].value == cityId) {
                b = cityData3[i].name;
              }
            }
            for (let i in cityData1) {
              if (cityData1[i].value == provinceId) {
                c = cityData1[i].name;
              }
            }
            res.data.provinceId = c;
            res.data.cityId = b;
            res.data.districtId = a;
            this.vipDetailList = res.data;
            this.shopMemberId = res.data.shopMemberId;
            this.shopMemberId2 = res.data.shopMemberId;
            provinceId = String(provinceId);
            cityId = String(cityId);
            if (districtId != 1) {
              districtId = String(districtId);
            }
            console.log(this.vipDetailList, "111");
            this.ruleForm = {
              fullName: res.data.fullName, //姓名
              phoneNum: res.data.phoneNum, //手机号码
              sex: res.data.sex == 1 ? "男" : "女", //性别
              shopMemberCardId: res.data.shopMemberCardId, //会员卡ID
              //完善 的信息 可选
              birthday: res.data.birthday, //生日 [可选]
              //地区 [可选]
              // provinceId: res.data.provinceId, //省 [可选]
              // cityId: res.data.cityId, //    市[可选]
              // districtId: res.data.districtId, // 区县 [可选]
              provinceId: [provinceId, cityId, districtId], //省 [可选]
              // provinceId:[2,1,19], //省 [可选]
              cityId: "", //    市[可选]
              districtId: "", // 区县 [可选]
              remark: res.data.remark //备注
            };
            console.log(this.ruleForm, "12321");
            if (!isGo) {
              this.shopMemberActivityList(this.vipDetailList.shopMemberCardId);
            }
          } else if (res.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            this.$message.error(res.msg);
          }

          console.log(res, "店铺会员列表详情");
        });
    },
    //分页当前页
    handleCurrentChange(val) {
      this.pageVal = val;
      var phoneNumber = ""
      phoneNumber = localStorage.getItem("phoneNumber")
      this.ShopMember_shopMemberPager(phoneNumber, val);
    },
    handleSizeChange(val) {
      console.log(val, "val")
      this.ShopMember_shopMemberPager("", 1, "", "", "", "",val);
    },
    //编辑划过
    editHover(e, a, isExpire) {
      // console.log(e, a, isExpire, "11");
      // a为会员卡是否是禁用状态
      if (a) {
        this.$refs[e][0].style.display = "block";
      } else {
        this.$refs[e][0].style.display = "block";
        this.$refs["none" + e][0].style.display = "none";
      }
      if (!isExpire) {
        this.$refs[e][0].style.display = "block";
      } else {
        this.$refs[e][0].style.display = "block";

        this.$refs["none2" + e][0].style.display = "none";
      }
    },
    editLeaver(e, a, isExpire) {
      if (a) {
        this.$refs[e][0].style.display = "none";
      } else {
        this.$refs[e][0].style.display = "none";
        this.$refs["none" + e][0].style.display = "block";
      }
      if (!isExpire) {
        this.$refs[e][0].style.display = "none";
      } else {
        this.$refs[e][0].style.display = "none";
        this.$refs["none2" + e][0].style.display = "block";
      }
    },
    //当前店铺的会员卡列表
    ShopMemberCard_shopMemberCardList() {
      this.request
        .post("qrcapi/ShopMemberCard_shopMemberCardList", {
          userId: this.userList.id, //用户Id
          sessionId: this.userList.sessionId
        })
        .then(res => {
          // console.log(res.data,'会员卡列表')
          var a = res.data;
          for (let i in a) {
            a[i].discount = (a[i].discount * 10).toFixed(1);
          }
          this.vipList = a;
          console.log(this.vipList, "this.vipList");
          console.log(res, "当前店铺的会员卡列表");
        });
    },
    //分享
    shareVip(index) {
      this.ewm = !this.ewm;
      console.log(this.ewm, index);
      this.shopMemberCardIds = this.vipList[index].shopMemberCardId
      this.discount = this.vipList[index].discount
      console.log(this.shopMemberCardIds, 'this.shopMemberCardIds')
      setTimeout(()=> {
        this.newqrcode(this.shopMemberCardIds)
      }, 0)
      var b = (index + 1) % 7;
      if (b == 0) {
        b = 6 * 220;
      } else {
        b = (b - 1) * 220;
      }
      console.log(b);
      this.left = 285 + b;
      var a = Math.ceil((index + 1) / 7) - 1;
      if (a < 0) {
        a = 0;
      } else if (a % 7 == 0) {
        a = 0;
      }
      this.top = 230 + a * 150;
    },
    toPages1() {
      this.pages = 1;
    },
    // 表单验证
    cardSubmitForm2(formName) {
      var ruleForm2 = this.ruleForm2;
      var fromColor = this.fromColor;
      var discount = (ruleForm2.discount / 10).toFixed(2);
      var startTime,
        endTime,
        expireDayNum,
        expireType,
        isEnable,
        openReceiveAfterPay,
        integralSwitch,
        fullConsume,
        integral,
        openReceiveInYSC,
        highSwitch,
        cardLevel,
        cumulateConsumeCount,
        cumulateConsumeMoney,
        cumulateScore,
        isDefault;
        if (this.ruleForm2.integralSwitch == true) {
        integralSwitch = 1
        fullConsume = 1
        if (this.integralValue == 1 || this.integralValue == '消费1元送1个积分') {
          integral = 1
        } else if (this.integralValue == 10 || this.integralValue == '消费1元送10个积分') {
          integral = 10
        } else if (this.integralValue == 100 || this.integralValue == '消费1元送100个积分') {
          integral = 100
        }
      } else {
        integralSwitch = 0
        fullConsume = null
        integral = null
      }
      if (ruleForm2.isEnable == "启用") {
        isEnable = 1;
      } else {
        isEnable = 0;
      }
      if (this.memberLevel == 1 && ruleForm2.highSwitch == true) {
        openReceiveAfterPay = 1;
      } else {
        openReceiveAfterPay = 0;
      }
      if (this.memberLevel == 1 && ruleForm2.highSwitch == true) {
        openReceiveInYSC = 1;
      } else {
        openReceiveInYSC = 0;
      }
      if (ruleForm2.expireType == "永久") {
        expireType = 0;
      } else if (ruleForm2.expireType == "按天") {
        expireType = 1;
        expireDayNum = ruleForm2.day;
      } else {
        expireType = 2;
        startTime = ruleForm2.time[0];
        endTime = ruleForm2.time[1];
      }
      if (ruleForm2.highSwitch == true) {
        highSwitch = 1
        cardLevel = this.memberLevel   
        cumulateConsumeCount = ruleForm2.cumulateConsumeCount
        cumulateConsumeMoney = ruleForm2.cumulateConsumeMoney
        cumulateScore = ruleForm2.cumulateScore
      } else {
        highSwitch = 0
        cardLevel = null
        cumulateConsumeCount = null
        cumulateConsumeMoney = null
        cumulateScore = null
        this.memberLevel = null
      }
      if (ruleForm2.highSwitch == true) {
        if (ruleForm2.cumulateConsumeCount >= 0 || ruleForm2.cumulateConsumeMoney >= 0 || ruleForm2.cumulateScore >= 0) {
          
        } else {
          this.$message.error("请输入会员等级相关信息")
          return
        }
      }
      if (this.ruleForm2.isDefault == true) {
        isDefault = 1
      } else {
        isDefault = 0
      }
      var that = this;
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.pages = 2;

          this.request
            .post("qrcapi/ShopMemberCard_modifyShopMemberCard", {
              sessionId: this.userList.sessionId,
              userId: this.userList.id,
              shopMemberCardId: this.shopMemberCardId.shopMemberCardId,
              cardName: ruleForm2.cardName, //卡名称
              cardSlogan: ruleForm2.cardSlogan, //标语
              discount: discount, //会员折扣
              expireType: expireType, // 0 永久 1 按天数 2 按日期
              expireDayNum: expireDayNum, //领取多少天后过期 有效时间 -1 永久  按天  按日期
              // 有效时间 -1 永久 按天 按日期
              startTime: startTime, //开始时间
              endTime: endTime, //结束时间
              servicePhone: ruleForm2.servicePhone, //客服电话
              useNotice: ruleForm2.useNotice, //使用须知
              isEnable: isEnable, //是否可用 1可用 0 不可用
              shopMemberCardColorId: fromColor.shopMemberCardColorId, //配色ID
              startValue: fromColor.startValue, //渐变开始值 #FFFFFF
              endValue: fromColor.endValue, //渐变结束值 #FFFFFF
              textColor: fromColor.textColor, //文字颜色#FFFFFF
              //支付后让用户领取
              openReceiveAfterPay: openReceiveAfterPay, // 0 : 关闭  1：开启
              //发布到易城市 让用户领取
              openReceiveInYSC: openReceiveInYSC, // 0 : 关闭  1：开启
              //钱如潮可领取 ---也叫做 自助领取开关
              integralSwitch: integralSwitch,
              fullConsume: fullConsume,
              integral: integral,
              highSwitch: highSwitch,
              cardLevel: cardLevel,
              cumulateConsumeCount: cumulateConsumeCount,
              cumulateConsumeMoney: cumulateConsumeMoney,
              cumulateScore: cumulateScore,
              isDefault: isDefault
            })
            .then(res => {
              console.log(res, "修改会员卡");
              if (res.code == 1) {
                this.$message({
                  type: "success",
                  message: res.msg
                });
                (this.ruleForm2 = {
                  cardName: "外婆家吃饭",
                  cardSlogan: "欢迎使用本店会员卡",
                  discount: 8.5,
                  expireType: "",
                  servicePhone: "",
                  expireDayNum: "",
                  cardBackGroup: "",
                  useNotice: "",
                  isEnable: "启用",
                  openReceiveAfterPay: true,
                  openReceiveInYSC: true,
                  day: "",
                  time: ""
                }),
                  this.ShopMemberCard_shopMemberCardList(); //刷新会员卡列表
              } else if (res.code == 2) {
                this.$message.error(res.msg);
                this.$router.push("/");
              } else {
                this.$message.error(res.msg);
              }
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    integralValueChange(val) {
      console.log(val, "integralValue")
      this.integralValue = val
    },
    memberLevelChange(val) {
      this.memberLevel = val
      if (this.memberLevel == 1) {
        this.ruleForm2.isDefault = true
      } else {
        this.ruleForm2.isDefault = false
      }
    },
    // 表单验证
    cardSubmitForm(formName) {
      console.log(this.ruleForm2, this.fromColor, "ruleForm2");
      // return
      var ruleForm2 = this.ruleForm2;
      var fromColor = this.fromColor;
      var discount = (ruleForm2.discount / 10).toFixed(2);
      var startTime,
        endTime,
        expireDayNum,
        expireType,
        isEnable,
        openReceiveAfterPay,
        integralSwitch,
        fullConsume,
        integral,
        openReceiveInYSC,
        highSwitch,
        cardLevel,
        cumulateConsumeCount,
        cumulateConsumeMoney,
        cumulateScore,
        isDefault;
      if (this.ruleForm2.integralSwitch == true) {
        integralSwitch = 1
        fullConsume = 1
        if (this.integralValue == 1) {
          integral = 1
        } else if (this.integralValue == 10) {
          integral = 10
        } else if (this.integralValue == 100) {
          integral = 100
        }
      } else {
        integralSwitch = 0
        fullConsume = null
        integral = null
      }
      if (ruleForm2.isEnable == "启用") {
        isEnable = 1;
      } else {
        isEnable = 0;
      }
      if (this.memberLevel == 1 && ruleForm2.highSwitch == true) {
        openReceiveAfterPay = 1;
      } else {
        openReceiveAfterPay = 0;
      }
      if (this.memberLevel == 1 && ruleForm2.highSwitch == true) {
        openReceiveInYSC = 1;
      } else {
        openReceiveInYSC = 0;
      }
      if (ruleForm2.expireType == "永久") {
        expireType = 0;
      } else if (ruleForm2.expireType == "按天") {
        expireType = 1;
        expireDayNum = ruleForm2.day;
      } else {
        expireType = 2;
        startTime = ruleForm2.time[0];
        endTime = ruleForm2.time[1];
      }
      if (ruleForm2.highSwitch == true) {
        highSwitch = 1
        cardLevel = this.memberLevel   
        cumulateConsumeCount = this.ruleForm2.cumulateConsumeCount
        cumulateConsumeMoney = this.ruleForm2.cumulateConsumeMoney
        cumulateScore = this.ruleForm2.cumulateScore
      } else {
        highSwitch = 0
        cardLevel = null
        cumulateConsumeCount = null
        cumulateConsumeMoney = null
        cumulateScore = null
        this.memberLevel = ""
      }
      if (ruleForm2.highSwitch == true) {
        if (ruleForm2.cumulateConsumeCount >= 0 || ruleForm2.cumulateConsumeMoney >= 0 || ruleForm2.cumulateScore >= 0) {
          
        } else {
          this.$message.error("请输入会员等级相关信息")
          return
        }
      }
      if (this.ruleForm2.isDefault == true) {
        isDefault = 1
      } else {
        isDefault = 0
      }
      this.$refs[formName].validate(valid => {
        if (valid) {
          // console.log(
          //   ruleForm2.cardName,
          //   "//卡名称",
          //   ruleForm2.cardSlogan,
          //   startTime,
          //   endTime,
          //   expireDayNum,
          //   expireType,
          //   isEnable,
          //   openReceiveAfterPay,
          //   openReceiveInYSC,
          //   discount,
          //   fromColor.startValue
          // );
          this.request
            .post("qrcapi/ShopMemberCard_createShopMemberCard", {
              sessionId: this.userList.sessionId,
              userId: this.userList.id,
              cardName: ruleForm2.cardName, //卡名称
              cardSlogan: ruleForm2.cardSlogan, //标语
              discount: discount, //会员折扣
              expireType: expireType, // 0 永久 1 按天数 2 按日期
              expireDayNum: expireDayNum, //领取多少天后过期 有效时间 -1 永久  按天  按日期
              // 有效时间 -1 永久 按天 按日期
              startTime: startTime, //开始时间
              endTime: endTime, //结束时间
              servicePhone: ruleForm2.servicePhone, //客服电话
              useNotice: ruleForm2.useNotice, //使用须知
              isEnable: isEnable, //是否可用 1可用 0 不可用
              shopMemberCardColorId: fromColor.shopMemberCardColorId, //配色ID
              startValue: fromColor.startValue, //渐变开始值 #FFFFFF
              endValue: fromColor.endValue, //渐变结束值 #FFFFFF
              textColor: fromColor.textColor, //文字颜色#FFFFFF
              //支付后让用户领取
              openReceiveAfterPay: openReceiveAfterPay, // 0 : 关闭  1：开启
              //发布到易城市 让用户领取
              openReceiveInYSC: openReceiveInYSC, // 0 : 关闭  1：开启
              //钱如潮可领取 ---也叫做 自助领取开关
              integralSwitch: integralSwitch,
              fullConsume: fullConsume,
              integral: integral,
              highSwitch: highSwitch,
              cardLevel: cardLevel,
              cumulateConsumeCount: cumulateConsumeCount,
              cumulateConsumeMoney: cumulateConsumeMoney,
              cumulateScore: cumulateScore,
              isDefault: isDefault
            })
            .then(res => {
              console.log(res, "创建会员卡");
              if (res.code == 1) {
                this.$message({
                  type: "success",
                  message: res.msg
                });
                (this.ruleForm2 = {
                  cardName: "外婆家吃饭",
                  cardSlogan: "欢迎使用本店会员卡",
                  discount: 8.5,
                  expireType: "",
                  servicePhone: "",
                  expireDayNum: "",
                  cardBackGroup: "",
                  useNotice: "",
                  isEnable: "启用",
                  openReceiveAfterPay: true,
                  openReceiveInYSC: true,
                  day: "",
                  time: ""
                }),
                  this.ShopMemberCard_shopMemberCardList(); //刷新会员卡列表
                this.pages = 2;
              } else if (res.code == 2) {
                this.$message.error(res.msg);
                this.$router.push("/");
              } else {
                this.$message.error(res.msg);
              }
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //修改会员信息
    editVipSubmitFrom(formName) {
      // console.log(this.ruleForm, "ss");
      var ruleForm = this.ruleForm;
      var sex = ruleForm.sex;
      var provinceId = Number(ruleForm.provinceId[0]);
      var cityId = Number(ruleForm.provinceId[1]);
      var districtId = Number(ruleForm.provinceId[2]);
      if (!districtId) {
        districtId = "";
      }
      if (!provinceId) {
        provinceId = "";
      }
      if (!cityId) {
        cityId = "";
      }
      if (sex == "男") {
        sex = 1;
      } else {
        sex = 0;
      }
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.request
            .post("qrcapi/ShopMember_modifyShopMember", {
              sessionId: this.userList.sessionId,
              userId: this.userList.id,
              fullName: ruleForm.fullName, //姓名
              shopMemberId: this.shopMemberId, //会员主键
              phoneNum: "", //手机号码
              sex: sex, //性别
              shopMemberCardId: ruleForm.shopMemberCardId, //会员卡ID
              //完善 的信息 可选
              birthday: ruleForm.birthday, //生日 [可选]
              //地区 [可选]
              provinceId: provinceId, // 省 [可选]
              cityId: cityId, //   市[可选]
              districtId: districtId, // 区县 [可选]
              remark: ruleForm.remark //备注
            })
            .then(res => {
              console.log(res, "会员开卡");
              if (res.code == 1) {
                this.$message({
                  type: "success",
                  message: res.msg
                });
                (this.ruleForm = {
                  fullName: "", //姓名
                  phoneNum: "", //手机号码
                  sex: "男", //性别
                  shopMemberCardId: "", //会员卡ID
                  //完善 的信息 可选
                  birthday: "", //生日 [可选]
                  //地区 [可选]
                  provinceId: "", //省 [可选]
                  cityId: "", //    市[可选]
                  districtId: "", // 区县 [可选]
                  remark: "" //备注
                }),
                  (this.editDetail = false);

                this.pages = 1;
              } else if (res.code == 2) {
                this.$message.error(res.msg);
                this.$router.push("/");
              } else {
                this.$message.error(res.msg);
              }
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //提交会员开卡
    submitForm(formName) {
      var myDate = new Date();
      var month = myDate.getMonth() + 1;
      let newTime = myDate.getFullYear() + "-" + month + "-" + myDate.getDate();
      console.log(this.ruleForm, "ss");
      var ruleForm = this.ruleForm;
      this.popShopMemberCardId = ruleForm.shopMemberCardId; //保存会员卡id
      var sex = ruleForm.sex;
      if (ruleForm.provinceId) {
        var provinceId = Number(ruleForm.provinceId[0]);
        var cityId = Number(ruleForm.provinceId[1]);
        var districtId = Number(ruleForm.provinceId[2]);
      } else {
        var provinceId = "";
        var cityId = "";
        var districtId = "";
      }
      if (sex == "男") {
        sex = 1;
      } else {
        sex = 0;
      }
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.request
            .post("qrcapi/ShopMember_getBindWxQrValue", {
              sessionId: this.userList.sessionId,
              userId: this.userList.id,
              fullName: ruleForm.fullName, //姓名
              phoneNum: ruleForm.phoneNum, //手机号码
              sex: sex, //性别
              shopMemberCardId: ruleForm.shopMemberCardId, //会员卡ID
              //完善 的信息 可选
              birthday: ruleForm.birthday, //生日 [可选]
              //地区 [可选]
              provinceId: provinceId, // 省 [可选]
              cityId: cityId, //   市[可选]
              districtId: districtId, // 区县 [可选]
              remark: ruleForm.remark, //备注
              becomeMemberTime: newTime //成为会员时间
            })
            .then(res => {
              console.log(res, "会员开卡");
              if (res.code == 1) {
                // console.log(res.data.qrCode, res.data.shopMemberId, "二维码内容")
                this.$message({
                  type: "success",
                  message: res.msg
                });
                (this.ruleForm = {
                  fullName: "", //姓名
                  phoneNum: "", //手机号码
                  sex: "男", //性别
                  shopMemberCardId: "", //会员卡ID
                  //完善 的信息 可选
                  birthday: "", //生日 [可选]
                  //地区 [可选]
                  provinceId: "", //省 [可选]
                  cityId: "", //    市[可选]
                  districtId: "", // 区县 [可选]
                  remark: "" //备注
                }),
                  (this.vip = 2);
                  setTimeout( () => {
                    this.useqrcode(res.data.qrCode)  // 此为绘画canvas的方法调用
                  }, 0)
                this.shopMemberId = res.data.shopMemberId
                this.shopMemberId2 = res.data.shopMemberId;
				this.mpNickName = res.data.mpNickName
                this.ShopMember_shopMemberPager("", this.pageVal); //会员列表
              } else if (res.code == 2) {
                this.$message.error(res.msg);
                this.$router.push("/");
              } else {
                this.$message.error(res.msg);
              }
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 点击会员开卡
    open() {
      this.$prompt("", "填写手机号", {
        confirmButtonText: "下一步",
        cancelButtonText: "取消",
        inputPlaceholder: "输入手机号码",
        inputPattern: /^1\d{10}$/,
        inputErrorMessage: "请输入正确手机号"
      })
        .then(({ value }) => {
          // this.$message({
          //   type: "success",
          //   message: "新建分组成功"
          // });
          this.disabled = true
          console.log(value, "phoneNum");
          this.request
            .post("qrcapi/ShopMember_findShopMember", {
              sessionId: this.userList.sessionId,
              userId: this.userList.id,
              phoneNum: Number(value)
            })
            .then( res => {
              this.disabled = false
              if (res.code == -1) {
                this.ruleForm.phoneNum = value;
                this.isPop = true;
              } else if (res.code == 1) {
                this.$message.success("此号码已经是会员")
                this.vipDetail(res.data.shopMemberId)
                console.log(res.data, "11111")
                this.popShopMemberCardId = res.data.shopMemberCardId
                this.pages = 3;
              } else if (res.code == 2) {
                this.$message.error(res.msg);
                this.$router.push("/");
              } else {
                this.$message.error(res.msg);
              }
            })
        })
        .catch(() => {
          // this.$message({
          //   type: "info",
          //   message: "取消输入"
          // });
        });
    },
    //验证只能数字
    change(val) {
      val = val.replace(/(^\s*)|(\s*$)/g, "");
      if (!val) {
        this.a = "";
        return;
      }
      var reg = /[^\d.]/g;

      // 只能是数字和小数点，不能是其他输入
      val = val.replace(reg, "");

      // 保证第一位只能是数字，不能是点
      val = val.replace(/^\./g, "");
      // 小数只能出现1位
      val = val
        .replace(".", "$#$")
        .replace(/\./g, "")
        .replace("$#$", ".");
      // 小数点后面保留2位
      val = val.replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3");

      this.a = val;
    }
  }
};
</script>

<style scoped>
.commodityHead {
  box-sizing: border-box;
  width: calc(100vw - 200px);
  padding: 15px 20px 15px 30px;
  background: #f8f8f8;
  height: 150px;
  padding-top: 65px;
  position: fixed;
  z-index: 99;
}
.pr5 {
  padding-right: 5px;
  box-sizing: border-box;
}
.button {
  width: 70px;
  height: 30px;
  padding: 0;
}
.button3 {
  width: 60px;
  height: 30px;
  padding: 0;
}
.button4 {
  width: 50px;
  height: 30px;
  padding: 0;
  margin-left: 10px;
}
.button2 {
  width: 70px;
  height: 30px;
  padding: 0;
  color: #409eff;
  border: 1px solid #409eff;
}
.button5 {
  width: 45px;
  height: 30px;
  padding: 0;
  color: #409eff;
  border: 1px solid #409eff;
}
.button6 {
  width: 70px;
  height: 30px;
  padding: 0;
  position: absolute;
  right: 20px;
  bottom: 24px;
}
.button7 {
  height: 20px;
  padding: 0 25px;
  color: #409eff;
  border: 1px solid #409eff;
  font-size: 13px;
  border-radius: 2px;
  padding-top: 5px;
  margin-left: 10px;
  margin-top: 15px;
}
.button8 {
  height: 27px;
  width: 140px;
  padding: 0;
  position: absolute;
  /* left: 34px; */
  /* bottom: -42px; */
  left: 70px;
  bottom: -127px;
  background: #1e75d9;
}
.img1 {
  height: 207px;
  width: 279px;
  position: absolute;
  top: 225px;
  left: 275px;
}
.img2 {
  position: relative;
}
.text2 {
  position: absolute;
  bottom: 34px;
  right: 40px;
  font-size: 12px;
  color: white;
  font-weight: 100;
  cursor: pointer;
}
.content {
  padding: 20px 30px;
  padding-top: 165px;
}
.content img {
  height: 30px;
  width: 30px;
}
.pop {
  height: 670px;
  width: 510px;
  background: #fff;
  z-index: 2001;
  position: fixed;
  border-radius: 5px;
}
.obs {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 2000;
}
.title {
  width: 470px;
  padding: 20px 0;
  padding-bottom: 10px;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #eee;
  margin-left: 20px;
}
.circle {
  background: #108ee9;
  height: 23px;
  width: 23px;
  border-radius: 50%;
}
.circle2 {
  background: #eee;
  height: 23px;
  width: 23px;
  border-radius: 50%;
}
.circleUp {
  background: #108ee9;
  height: 28px;
  width: 28px;
  border-radius: 50%;
  position: relative;
}
.circle-white {
  /* background: #fff; */
  border: 1.5px solid #fff;
  height: 23px;
  width: 23px;
  border-radius: 50%;
  position: absolute;
  top: 1px;
  left: 1px;
}
.br2 {
  height: 2px;
  background: #108ee9;
  width: 130px;
}
.br3 {
  height: 2px;
  background: #eee;
  width: 130px;
}
.plan {
  height: 95px;
}
/* .text div:not(:first-child) {
  margin-left: 120px;
} */
.text {
  display: flex;
  width: 350px;
  justify-content: space-between;
  margin-top: 15px;
  font-size: 13px;
}
.content1 {
  box-sizing: border-box;
  background: #f3f3f3;
  width: 100%;
  padding: 10px 20px;
  font-size: 13px;
}
.price {
  font-size: 13px;
  width: 340px;
  margin-top: 20px;
}
.money div {
  display: inline-block;
}
.money {
  width: 340px;
}
.moneyButton {
  position: absolute;
  right: 20px;
  bottom: 20px;
}
.vipDetail {
  font-size: 13px;
}
.content2 {
  color: #777;
  font-size: 16px;
  margin-left: 20px;
}
.content2 div {
  margin-top: 25px;
}
.content2-text {
  color: #000;
}
.addVip {
  padding: 25px 45px;
  padding-top: 115px;
}
.addVip-content {
  font-size: 14px;
  margin-top: 24px;
  font-size: 14px;
  color: #606266;
}

.pcikColor {
  height: 30px;
  width: 85px;
  border: 1px solid #bbb;
  margin-left: 30px;
}
.small {
  height: 20px;
  width: 75px;
}
.square {
  height: 17px;
  width: 17px;
  display: inline-block;
}
.square:not(:first-child) {
  margin-left: 11px;
}
/* .square:nth-child(7) {
  margin-left: 0px;
} */
.input1 {
  width: 780px;
}
.input2 {
  width: 190px;
}
.vipCard {
  position: relative;
  margin-top: 20px;
  margin-left: 10px;
}
.totalVip {
  position: relative;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.vipCard .name {
  color: #c3445e;
  font-size: 14px;
  position: absolute;
  top: 9px;
  left: 25px;
  font-weight: 1000;
}
.vipCard .welcome {
  font-size: 12px;
  color: #fff;
  position: absolute;
  top: 32px;
  left: 25px;
}
.vipCard .time {
  font-size: 12px;
  color: rgb(250, 250, 250);
  position: absolute;
  top: 67px;
  left: 25px;
}
.vipCard .discount {
  text-align: right;
  width: 55px;
  font-size: 12px;
  color: rgb(250, 250, 250);
  position: absolute;
  top: 33px;
  left: 147px;
}
.share {
  width: 196px;
  position: absolute;
  top: 100px;
  left: 15px;
  color: rgb(250, 250, 250);
  font-size: 12px;
}
.changeColor {
  height: 123px;
  width: 196px;
  margin-left: 15px;
  border-radius: 10px;
  box-shadow: 2px 2px 8px #888888;
}
.content2-ygq {
  border: 1px solid #f62323;
  color: #f62323;
  border-radius: 5px;
  padding: 2px 7px;
}
.content2-ygq2 {
  border: 1px solid #f62323;
  color: #f62323;
  border-radius: 5px;
  font-size: 10px;
  padding: 2px 8px;
}
.content2-jyz {
  border: 1px solid #f6ae23;
  color: #f6ae23;
  border-radius: 5px;
  padding: 2px 7px;
}
.content2-jyz2 {
  border: 1px solid #f6ae23;
  color: #f6ae23;
  font-size: 10px;
  border-radius: 5px;
  padding: 2px 7px;
}
.isEnable {
  position: absolute;
  right: 1250px;
  top: 68px;
}
.isEnable2 {
  position: absolute;
  right: 30px;
  top: 0px;
}
#canvas{
  width: 50%!important;
  height: auto!important;
  position: absolute;
  left: 127px;
  top: 237px;
}
#canvas1 {
  /* width: 30%!important; */
  height: auto!important;
  position: absolute; 
  /* top: 97px;  */
  /* left: 62px; */
  width: 38%!important;
  top: 134px;
  left: 88px;
}
.shopNameClass {
  /* font-size: 12px;
  position: absolute;
  top: 51px;
  left: 77px; */
  font-size: 15px;
  position: absolute;
  top: 69px;
  left: 107px;
}

</style>


// WEBPACK FOOTER //
// src/components/page/customer.vue